module.exports = __webpack_public_path__ + "img/back_width.f19e900c.png";